<template>
    <div class="animated fadeIn">
        <b-card class="document-view" style="padding:0;margin:0">
            <b-row>
                <b-col lg="12">
                    <b-card style="margin-top: 0">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                            <b-row>
                                <b-col>
                                    <b-link v-b-toggle.accordion-sync-info>
                                        Xem chi tiết biến động thay đổi thông tin tài sản
                                        <span class="when-opened pull-right">
                                            <i class="fa fa-chevron-down" aria-hidden="true"></i>
                                        </span>
                                        <span class="when-closed pull-right">
                                            <i class="fa fa-chevron-up" aria-hidden="true"></i>
                                        </span>
                                    </b-link>
                                </b-col>
                            </b-row>
                        </b-card-header>
                        <b-collapse id="accordion-sync-info" visible role="tabpanel">
                            <b-card-body>
                                <b-row>
                                    <b-col md="6">
                                        <b-form-group label="Phần mềm đồng bộ: "
                                                      :label-cols="4"
                                                      label-class="label-bold"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="$store.getters.getSyncSourceType(assetMutation.syncSourceType)" :title="$store.getters.getSyncSourceType(assetMutation.syncSourceType)" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6">
                                        <b-form-group label="Ngày đồng bộ:"
                                                      :label-cols="4"
                                                      label-class="label-bold"
                                                      label-align="left"
                                                      :horizontal="true">
                                            <b-form-input :value="assetMutation.syncDate | formatTime" :title="assetMutation.syncDate | formatTime" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6">
                                        <b-form-group label="Đơn vị đồng bộ:"
                                                      :label-cols="4"
                                                      label-class="label-bold"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="assetMutation.syncUnitName" :title="assetMutation.syncUnitName" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6">
                                        <b-form-group label="Tài khoản đồng bộ:"
                                                      :label-cols="4"
                                                      label-class="label-bold"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="assetMutation.syncUserName" :title="assetMutation.syncUserName" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6">
                                        <b-form-group label="Mã tài sản tại kho: "
                                                      title="Mã tài sản tại kho do kho cấp (tự động sinh)"
                                                      :label-cols="4"
                                                      label-class="label-bold"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="assetMutation.assetCode" :title="assetMutation.assetCode" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6">
                                        <b-form-group label="Mã tài sản tại đơn vị: "
                                                      :label-cols="4"
                                                      label-class="label-bold"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="assetMutation.sourceAssetCode" :title="assetMutation.sourceAssetCode" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6">
                                        <b-form-group label="Loại biến động: "
                                                      :label-cols="4"
                                                      label-class="label-bold"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="assetMutation.assetMutationTypeName" :title="assetMutation.assetMutationTypeName" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col md="6">
                                        <b-form-group label="Ngày biến động: "
                                                      :label-cols="4"
                                                      label-class="label-bold"
                                                      :horizontal="true"
                                                      label-align="left">
                                            <b-form-input :value="assetMutation.mutationDate | formatDate" :title="assetMutation.mutationDate | formatDate" :readonly="true"></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                </b-row>
                            </b-card-body>
                        </b-collapse>
                    </b-card>

                    <b-row style="margin:0">
                        <template v-for="(group, index) in customFieldGroups">
                            <b-card :class="`no-padding col-md-${group.ref.displayGridColumn}`">
                                <b-card-header header-tag="header" class="p-1" role="tab">
                                    <b-row>
                                        <b-col>
                                            <b-link v-b-toggle="'accordion-group-' + group.ref.text">
                                                {{ group.ref.text }}
                                                <span class="when-opened pull-right">
                                                    <i class="fa fa-chevron-down" aria-hidden="true"></i>
                                                </span>
                                                <span class="when-closed pull-right">
                                                    <i class="fa fa-chevron-up" aria-hidden="true"></i>
                                                </span>
                                            </b-link>
                                        </b-col>
                                    </b-row>
                                </b-card-header>

                                <b-collapse :id="'accordion-group-' + group.ref.text" visible role="tabpanel">
                                    <b-card-body>
                                        <b-row>
                                            <template v-for="(field, index) in group.fields">
                                                <template v-if="field.isDisplayed">
                                                    <div class="col-12" v-if="field.displayNewLine"></div>
                                                    <b-col :md="field.displayGridColumn" class="editable">
                                                        <b-form-group :label="getFieldLabel(field)"
                                                                      :label-cols="field.displayLabelColumn"
                                                                      :label-class="getLabelClass(field)"
                                                                      :title="getFieldTitle(field)"
                                                                      :horizontal="true"
                                                                      label-align="left">
                                                            <template v-if="field.dataType == 'FILE'">
                                                                <label class="col-form-label"><b-link href="javascript:void(0)" @click="downloadAttachment">{{ getFieldValue(field) }}</b-link></label>
                                                            </template>
                                                            <template v-else>
                                                                <template v-if="field.dataType == 'NUMBER(1,0)' && !field.format">
                                                                    <b-form-checkbox v-model="field.value" disabled="disabled"></b-form-checkbox>
                                                                </template>
                                                                <template v-else>
                                                                    <template v-if="typeof(field.value) == 'object' && field.value != null">
                                                                        <json-field :value="field.value"></json-field>
                                                                        <!--<json-viewer :data="JSON.stringify(field.value)"></json-viewer>-->
                                                                    </template>
                                                                    <template v-else>
                                                                        <input-auto-size :value="getFieldValue(field)" :title="getFieldValue(field)" v-if="field.name"></input-auto-size>
                                                                    </template>
                                                                </template>
                                                            </template>
                                                        </b-form-group>
                                                    </b-col>
                                                    <template v-if="field.name == null && field.displayName.toLocaleLowerCase().indexOf('hien trang') != -1">
                                                        <b-col md="2" v-for="usage in assetMutation.usageStates" :key="usage.id">
                                                            <b-form-group :label="usage.name"
                                                                          :title="usage.name"
                                                                          :horizontal="true"
                                                                          label-align="left">
                                                                <b-form-input v-if="usage.isAreaUsage" :value="usage.value | formatNumber" :title="usage.value | formatNumber" :readonly="true"></b-form-input>
                                                                <b-checkbox disabled v-else v-model="usage.value >= 1"></b-checkbox>
                                                            </b-form-group>
                                                        </b-col>
                                                    </template>
                                                </template>
                                            </template>
                                        </b-row>
                                    </b-card-body>
                                </b-collapse>
                            </b-card>
                        </template>
                    </b-row>


                    <b-card style="margin-top: 0; padding-top: 0">
                        <b-row>
                            <b-col class="text-center">
                                <div class="form-group">
                                    <b-button type="button" :to="{ path: './list' }">Quay lại</b-button>
                                    <b-button type="button" :to="{ path: `../${assetMutation.assetId}` }">Xem chi tiết tài sản</b-button>
                                </div>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-col>
            </b-row>
        </b-card>
    </div>

</template>
<script>
    import JsonField from '@/components/JsonField';

    export default {
        name: 'AssetMutationDetail',
        components: {
            JsonField
        },
        data() {
            return {
                assetMutation: {}
            }
        },
        computed: {
            assetMutationId() {
                return this.$route.params.assetMutationId;
            },
            customFieldGroups() {
                if (!this.assetMutation.customFields || this.assetMutation.customFields.length == 0) return [];

                var data = this.assetMutation.customFields;
                var groupBy = _(data).groupBy(x => x.groupId).sortBy(group => data.indexOf(group[0])).value();
                var groups = [];

                for (var i = 0; i < groupBy.length; i++) {
                    groups.push({ ref: groupBy[i][0].group || { text: 'undefined' }, fields: groupBy[i] });
                }

                return groups;
            }
        },
        created() {
            this.loadAssetMutationDetail();
        },
        methods: {
            loadAssetMutationDetail() {
                var vm = this;
                return this.$services.get(`data/asset-mutations/${this.assetMutationId}`).done(assetMutation => {
                    for (var i = 0; i < assetMutation.customFields.length; i++) {
                        if (assetMutation.customFields[i].groupId) {
                            assetMutation.customFields[i].group = assetMutation.customGroups.find(x => x.id == assetMutation.customFields[i].groupId);
                        }
                    }
                    vm.assetMutation = assetMutation;
                    scrollToTop();
                });
            },
            getLabelClass(field) {
                var classes = '';

                //if (field.isRequired) {
                //    classes += ' required';
                //}

                if (field.displayLabelBold) {
                    classes += ' label-bold';
                }

                if (field.displayLabelItalic) {
                    classes += ' label-italic';
                }

                if (field.displayLabelNone) {
                    classes += ' label-none';
                }

                return classes;
            },
            getFieldLabel(field) {
                var index = field.displayName.indexOf('.');
                return index == - 1 ? field.displayName : field.displayName.substr(0, index);
            },
            getFieldTitle(field) {
                return field.name;
                //var index = field.displayName.indexOf('.');
                //return index == - 1 ? null : field.displayName.substr(index);
            },
            getFieldValue(field) {
                //if (field.name == "OTHER_INFORMATION") {
                //    try {
                //        var jsonObj = JSON.parse(field.value);
                //        var value = '';

                //        for (var p in jsonObj) {
                //            if (value != '') {
                //                value += '\n';
                //            }
                //            value += `- ${p} : ${jsonObj[p]}`;
                //        }
                //        return value;
                //    } catch {
                //        return field.value;;
                //    }
                //}

                if (field.format != null) {
                    return field.format;
                } else if (field.lookupValue != null) {
                    return field.lookupValue;
                }

                return field.value;
            },
            downloadAttachment() {
                this.$services.download(`data/asset-mutations/${this.assetMutationId}/attachment`);
            }
        }
    }
</script>
<style scoped>

    label {
        font-weight: 400;
        font-style: italic;
    }

    .text-1 {
        font-weight: 500;
    }

    .card {
        margin-bottom: 0;
        margin-top: 1rem;
        border: none;
    }
</style>
